import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    evaluations: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_SCORECARD_SELECT_IDS (store, ids) {
      store.evaluations.selectIds = ids
    },
    REMOVE_SCORECARD_SELECT_IDS (store, ids) {
      store.evaluations.selectIds = store.evaluations.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_SCORECARD_SELECT_ID (store, id) {
      store.evaluations.selectId = id
    },
    SET_SCORECARD_FILTERS (store, filters) {
      store.evaluations.filters = filters
    },
    SET_SCORECARD_PAGINATE (store, val) {
      store.evaluations.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getEvaluations: (store, getters) => {
      return store.evaluations.selectIds.map((id) => {
        return getters['entities/evaluations/find'](id)
      })
    },
    getEvaluationsFilters: (store, getters) => {
      return store.evaluations.filters
    },
    getEvaluationsPaginate: (store, getters) => {
      return store.evaluations.paginate
    },
    getEvaluation: (store, getters) => {
      return getters['entities/evaluations/find'](store.evaluations.selectId) || {}
    }
  },
  actions: {
    /*
    selectEvaluations
    */
    selectEvaluations ({commit, dispatch, getters, state}, filters) {
      return dispatch('getEvaluations', filters)
      .then((response) => {
        commit('SET_SCORECARD_FILTERS', filters)
        commit('SET_SCORECARD_PAGINATE', response)
        commit('SET_SCORECARD_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectEvaluations
    */
    refreshSelectEvaluations ({commit, dispatch, getters, state}) {
      return dispatch('selectEvaluations', getters.getEvaluationsFilters)
    },
    /*
    selectEvaluation
    */
    selectEvaluation ({commit, dispatch, getters, state}, id) {
      return dispatch('getEvaluationById', id)
      .then((response) => {
        commit('SET_SCORECARD_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getEvaluations
    */
    getEvaluations ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/evaluations`, {params: filters})
      .then((response) => {
        return dispatch('entities/evaluations/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.evaluations || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getEvaluationById
    */
    getEvaluationById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/evaluations/${id}`)
      .then((response) => {
        return dispatch('entities/evaluations/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.evaluations[0]
      })
    },
    /*
    createEvaluation
    */
    createEvaluation ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/evaluations`, data)
      .then((response) => {
        return dispatch('entities/evaluations/insert', {
          data: response.data
        })
      })
      .then((response) => {
        dispatch('changeEvaluation', {})
        return response.evaluations[0]
      })
    },
    /*
    createAutoEvaluation
    */
    createAutoEvaluation ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/evaluations/auto`, data)
      .then((response) => {
        return dispatch('entities/evaluations/insert', {
          data: response.data
        })
      })
      .then((response) => {
        dispatch('changeEvaluation', {})
        return response.evaluations[0]
      })
    },
    /*
    updateEvaluation
    */
    updateEvaluation ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/evaluations/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/evaluations/insert', {
          data: response.data
        })
      })
      .then((response) => {
        dispatch('changeEvaluation', {})
        return response.evaluations[0]
      })
    },
    /*
    deleteEvaluation
    */
    deleteEvaluation ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/evaluations/${id}`)
      .then((response) => {
        commit('REMOVE_SCORECARD_SELECT_IDS', [id])
        dispatch('entities/evaluations/delete', id)
        dispatch('changeEvaluation', {})
        return {}
      })
    },
    /*
    changeEvaluation
    */
    changeEvaluation ({commit, dispatch, getters, state}, data) {
      if (getters.getCandidate._id) {
        dispatch('getCandidateById', getters.getCandidate._id)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Evaluation.js